export default __webpack_public_path__ + "static/media/scroll.c9e9407a.png";